import { Injectable } from "@angular/core";
import { CalculationBaseStoreService } from "../calculation-base/calculation-base.store.service";
import { BalanceByTimeAndAccountsCalculatedCollection } from "@bitwarden/web-vault/app/services/store/calculation-past/balances/balance-by-time-and-accounts.calculated.collection";
import {
  BalanceCalculatedPastAdapterType,
  CalculatedPastStoreAdapterInterface,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";
import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import { BalanceByTransactionsCalculatedCollection } from "@bitwarden/web-vault/app/services/store/calculation-past/balances/balance-by-transactions.calculated.collection";
import { BalanceByTimeCalculatedCollection } from "@bitwarden/web-vault/app/services/store/calculation-past/balances/balance-by-time.calculated.collection";
import { PastPeriodController } from "@bitwarden/web-vault/app/services/store/calculation-past/controls/past-period.control";

@Injectable({
  providedIn: "root",
})
export class CalculationPastStoreService
  extends CalculationBaseStoreService
  implements CalculatedPastStoreAdapterInterface<BalanceCalculatedPastAdapterType>
{
  // Override the period controller with past-specific logic (12-month default limit)
  override period = new PastPeriodController();

  balanceByTimeAndAccounts = new BalanceByTimeAndAccountsCalculatedCollection();
  balanceByTime = new BalanceByTimeCalculatedCollection();
  balanceByTransaction = new BalanceByTransactionsCalculatedCollection();

  protected clearBalanceCollections(): void {
    this.balanceByTimeAndAccounts.clear();
    this.balanceByTime.clear();
    this.balanceByTransaction.clear();
  }

  async updateBalanceCalculations(
    calculatedGeneratedTransactions: TransactionView[],
  ): Promise<void> {
    const parameters = {
      calculatedTransactions: calculatedGeneratedTransactions,
      webWorkerQueue: this.webWorkerQueue,
      filter: this.filters.selected(),
      group: this.groupings.selected(),
      period: this.period.selected(),
    };

    const promises: Promise<void>[] = [];

    promises.push(this.balanceByTime.updateCalculations(parameters));
    promises.push(this.balanceByTransaction.updateCalculations(parameters));
    promises.push(this.balanceByTimeAndAccounts.updateCalculations(parameters));

    await Promise.all(promises);
    return;
  }

  protected async updateCalculation() {
    this.appState.startProcess("balance-calculation-past", "Calculating Balances...");
    await super.updateCalculation();
    this.appState.endProcess("balance-calculation-past");
  }
}
